/**
 * GIFT4TEE — popup "Added to cart successfully".
 *
 * Theme khong co san kieu thong bao nay: setting `action_after_atc` chi co 4
 * lua chon (khong lam gi / mo cart drawer / sang trang gio / sang checkout).
 * Da dat setting do ve "no" trong config/settings_data.json de cart drawer
 * khong bat ra, roi tu bat su kien ma theme phat sau khi them vao gio.
 *
 * Su kien: `cart:update` (assets/events.js — ThemeEvents.cartUpdate), bubble
 * len document tu the <hdt-product-form>. detail gom:
 *   source          'product-form-component' khi la thao tac them vao gio
 *   actionAfterATC  gia tri input[name=action_added] cua chinh form do
 *   data.didError   true khi them that bai
 *
 * Form upsell trong cart drawer / trang gio co san input action_added="no"
 * (sections/cart-drawer.liquid:231, sections/main-cart.liquid:122) — dua vao
 * do de khong bat popup khi khach dang o trong gio hang.
 */
(function () {
  'use strict';

  var dialog = document.getElementById('g4t-atc');
  // <dialog> khong ho tro (trinh duyet rat cu) thi bo qua, theme van chay binh thuong
  if (!dialog || typeof dialog.showModal !== 'function') return;

  // Dang o trang gio hang thi khong bat popup: khach dang xem chinh cai gio roi,
  // bao "da them vao gio" nua la thua. Quan trong hon: o vuong ban them cua
  // assets/g4t-cart.js goi /cart/add.js, duong du phong ben duoi se hieu nham
  // day la mot luot them vao gio.
  if (((window.themeHDN && themeHDN.settings) || {}).pageType === 'cart') return;

  var itemsEl = dialog.querySelector('[data-g4t-atc-items]');
  var settings = (window.themeHDN && window.themeHDN.settings) || {};
  var moneyFormat = settings.currencyFormat || settings.moneyFormat || '${{amount}}';

  // doc muon Shopify.routes: script nay chay som hon script cua Shopify o head
  // trong vai truong hop, nen khong cache luc khoi tao
  function cartUrl() {
    return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js';
  }

  /* ---------------------------------------------------------------- helpers */

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function digits(cents, places, thousand, decimal) {
    var parts = (Number(cents || 0) / 100).toFixed(places).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  /**
   * formatMoney cua theme nam trong module nen khong goi tu ngoai duoc — dung
   * lai theo dung cac placeholder Shopify ho tro trong money_format.
   */
  function money(cents) {
    var token = /\{\{\s*(\w+)\s*\}\}/;
    var found = moneyFormat.match(token);
    if (!found) return moneyFormat;
    var value;
    switch (found[1]) {
      case 'amount_no_decimals':
        value = digits(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = digits(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = digits(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = digits(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = digits(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = digits(cents, 0, ' ', ',');
        break;
      default:
        value = digits(cents, 2, ',', '.');
    }
    return moneyFormat.replace(token, value);
  }

  function thumbUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* ------------------------------------------------------------------ render */

  function itemHtml(item) {
    var url = esc(item.url);
    var src = thumbUrl(item.image, 180);
    var thumb = src
      ? '<a class="g4t-atc__thumb" href="' + url + '" tabindex="-1">' +
        '<img src="' + esc(src) + '" alt="" width="90" height="90" loading="lazy"></a>'
      : '<span class="g4t-atc__thumb g4t-atc__thumb--empty"></span>';

    // variant_title la null khi san pham chi co mot phuong an mac dinh
    var variant = item.variant_title
      ? '<p class="g4t-atc__variant">' + esc(item.variant_title) + '</p>'
      : '';

    var qty = Number(item.quantity) || 1;
    // final_line_price = don gia sau giam nhan so luong, /cart.js tinh san. Mua tu
    // 2 cai tro len thi ghi ro phep nhan, mot cai thi khong can cho khoi rom ra.
    var price = money(item.final_line_price);
    if (qty > 1) {
      // &times; chu khong phai ky tu × de file nay giu nguyen ASCII
      price += ' <span class="g4t-atc__calc">(' + money(item.final_price) + ' &times; ' + qty + ')</span>';
    }

    return (
      '<div class="g4t-atc__item">' +
      thumb +
      '<div class="g4t-atc__info">' +
      '<a class="g4t-atc__name" href="' + url + '">' + esc(item.product_title) + '</a>' +
      variant +
      '<p class="g4t-atc__qty">Quantity: ' + qty + '</p>' +
      '<p class="g4t-atc__price">' + price + '</p>' +
      '</div>' +
      '</div>'
    );
  }

  /* -------------------------------------------------------------- open/close */

  var scrollLocked = false;

  function open() {
    if (dialog.open) return;
    dialog.showModal();
    // Safari/Firefox khong tu khoa cuon nen trang khi mo <dialog>
    document.documentElement.style.overflow = 'hidden';
    scrollLocked = true;
  }

  dialog.addEventListener('close', function () {
    if (!scrollLocked) return;
    document.documentElement.style.overflow = '';
    scrollLocked = false;
  });

  dialog.addEventListener('click', function (event) {
    // bam ra vung toi ben ngoai: target chinh la <dialog> vi noi dung nam trong
    // .g4t-atc__inner, khong phai con truc tiep cua vung bam
    if (event.target === dialog || event.target.closest('[data-g4t-atc-close]')) {
      dialog.close();
    }
  });

  /* ------------------------------------------------------------------ listen */

  var pending = false;
  var lastShown = 0;

  /**
   * Dong bo lai phan gio hang cua theme.
   *
   * So tren icon gio (<hdt-cart-count>, snippets/header_group_icons.liquid:108) chi
   * doi khi nghe su kien `cart:count:update`. Su kien do do handler cart:update cua
   * <hdt-cart-drawer> ban ra, ma handler do doc detail.cartData.sections[sectionId]
   * ngay dong dau — thieu sections la nem TypeError va cai dong dispatch nam ngay
   * sau se khong bao gio chay. Da co so chinh xac tu /cart.js roi nen ban thang,
   * khong phu thuoc chuoi do nua. Ban nhieu lan cung khong sao: listener chi gan
   * textContent = so nhan duoc.
   *
   * Ban them `cart:reload` de chinh theme goi /cart/update roi ve lai ruot cart
   * drawer (danh sach dong hang, tam tinh, thanh free shipping) — khong thi mo gio
   * ra van thay so lieu cu. Duong nay chay voi source 'reload' nen khong quay lai
   * bat popup lan nua.
   */
  function syncCart(itemCount) {
    if (typeof itemCount === 'number') {
      document.dispatchEvent(
        new CustomEvent('cart:count:update', { detail: { item_count: itemCount } })
      );
    }
    document.dispatchEvent(new CustomEvent('cart:reload'));
  }

  function showCart() {
    // hai duong kich hoat ben duoi co the cung ban mot luc — chan mo hai lan
    if (pending || Date.now() - lastShown < 1000) return;
    pending = true;
    lastShown = Date.now();

    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        syncCart(cart.item_count);
        itemsEl.innerHTML = cart.items.map(itemHtml).join('');
        open();
      })
      .catch(function (error) {
        // that bai thi im lang, khach van thay so luong tren icon gio cap nhat
        console.error('[g4t-atc-popup]', error);
      })
      .then(function () {
        pending = false;
      });
  }

  /* Duong 1 — su kien cua theme. Sach nhat, nhung phu thuoc vao custom element
     <wrapp-hdt-pr-frm> chay dung va su kien noi len duoc toi document. */
  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    if (detail.source !== 'product-form-component') return;
    if (detail.actionAfterATC === 'no') return;
    if (detail.data && detail.data.didError) return;
    showCart();
  });

  /* Duong 2 — bat thang loi goi POST /cart/add.js. Du phong cho truong hop
     duong 1 khong ban (JS theme loi, form cua app khac, quick add...).
     Chi doc response.ok chu khong doc body nen khong tranh cho ai ca: body cua
     Response chi bi tieu thu khi goi .json()/.text(). */
  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      // phai goi voi this = window, khong phai this cua ham bao (undefined o
      // che do strict) — vai trinh duyet nem "Illegal invocation"
      var result = nativeFetch.apply(window, arguments);
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && url.indexOf('/cart/add') > -1) {
          result
            .then(function (response) {
              // Shopify tra 422 khi them that bai (het hang, sai bien the...)
              if (response && response.ok) showCart();
            })
            .catch(function () {});
        }
      } catch (error) {
        /* khong duoc lam hong fetch cua trang vi mot loi phu tro */
      }
      return result;
    };
  }

  console.info('[g4t-atc-popup] san sang');
})();
